<template>

    <div class="container">       

        <!--
        <b-button id="show-btn" @click="openStarRatingModal()">Open Modal</b-button> 
        -->      

        <b-modal id="star-rating-modal" centered header-class="bg-blue text-white" size="xl" no-auto-focus @hide="resetModalVariables">

            <template #modal-title>
                レッスンの評価をカーソルを使って★を付けてください
            </template>

            <template #modal-header-close>
                <span aria-hidden="true" class="text-white">&times;</span>
            </template>

            <template #default>

                <div id="schedule-entry-container" class="row" v-if="schedules.length >= 1" >

                    <div id="schedule-entry-wrapper" class="col-7">

                        <div class="alert alert-danger" role="alert" v-if="hasErrorAlert">
                            ❌ {{ errorAlertMessage }}
                        </div>

                        <div id="schedule-entry" v-if="!submitted">
                            <!-- [start] Lesson Information -->
                            <div class="row">
                                <!-- Image Column -->
                                <div class="col-3">
                                    <div class="small" v-if="schedule">
                                        <img id="teacherPhoto" class="tutorPhotoBorder img-responsive w-100"
                                            :src="getStorageUrl(schedule.original)" />
                                    </div>
                                </div>
                                <!-- Name Information Column -->
                                <div class="col-sm-9">

                                    <div class="lesson_info_container">
                                        <span class="font-weight-bold">Lesson Start Time: </span>
                                        <span id="lesson_time" v-if="schedule">
                                            {{ schedule.formatted_lesson_time }}
                                        </span>
                                    </div>
                                    <div class="lesson">
                                        
                                        <span class="font-weight-bold">Lesson End Time:</span>    

                                        <span v-if="schedule && schedule.consecutive.after.length >= 1">
                                            {{ schedule.consecutive.after[schedule.consecutive.after.length -1].formatted_end_lesson_time }}
                                        </span>
                                        <span v-else>
                                            {{ schedule.formatted_end_lesson_time }}
                                        </span>                                 
                                        
                                        <div id="lesson-count">
                                            <span class="font-weight-bold">
                                                Number of Lessons 
                                                <a href="#" @click.stop.prevent="showSchedules(schedule)" v-if="schedule && schedule.consecutive.after.length >= 1">
                                                    <span style="display:inline-flex; align-items:center; justify-content:center; width:22px; height:22px; border-radius:50%; background-color: #9191919e;">
                                                        <i class="fa fa-question text-white"></i>
                                                    </span>
                                                </a>
                                            </span>
                                            <span>
                                                {{ schedule.consecutive.after.length + 1}}                                                                                               
                                            </span>
                                            <span v-if="schedule.consecutive.after.length >= 1">consecutive lessons</span>
                                            <span v-else>lesson</span>
                                        </div>
                                    </div>                                             
                                    

                                    <div class="text-small">
                                        <div class="name_japanese">
                                            <span class="font-weight-bold">Name (Japanese):</span>
                                            <span id="tutor_fullname_japanese" v-if="schedule">
                                                {{ schedule.japanese_firstname }}
                                            </span>
                                        </div>

                                        <div class="name_english">
                                            <span class="font-weight-bold">Name (English):</span>
                                            <span id="tutor_fullname" v-if="schedule">
                                                {{ schedule.firstname }}
                                            </span>
                                        </div>
                                    </div>


                                    <div class="star-rating-container my-2">
                                        <span class="font-weight-bold">
                                            Please rate your teacher by selecting the stars.
                                        </span>
                                        <div class="star-rating mb-4">
                                            <i v-for="star in 5" :key="star" class="fa fa-star fa-2x mr-1"
                                                :class="{ hover: star <= hoverRating, selected: star <= selectedRating }"
                                                @mouseenter="hoverRating = star" @mouseleave="hoverRating = 0"
                                                @click="selectRating(star)"></i>
                                        </div>
                                        <input type="hidden" id="rating-input" :value="selectedRating" />
                                    </div>
                                </div>
                            </div>
                            <!-- [end] Lesson Information -->
                            <!-- [start] Teacher Feedback-->
                            <div class="mb-3">
                                ご意見やご感想がございましたら、こちらにご入力ください。
                                <textarea id="teacherFeedback" name="teacherFeedback" rows="4" cols="50"
                                    class="form-control" v-model="teacherFeedback"></textarea>
                            </div>
                            <!-- [end] Teacher Feedback -->
                        </div>

                        <div v-else id="schedule-entry-submitted-container">
                           
                            <div class="my-4">
                                <div class="text-center">✅ ご評価ありがとうございました！</div>
                            </div>
                        </div>                      

                    </div>

                    <!-- [start] schedule list-->
                    <div id="schedule-list" class="col-5" v-if="schedules">
                        <div class="list-group scrollable-list-group">

                            <button :id="'schedule-'+schedule.id" type="button" 
                                class="list-group-item list-group-item-action"
                                :class="{ active: schedule.id === activeScheduleId }"
                                v-for="(schedule, index) in schedules" :key="schedule.id"
                                @click="setActiveSchedule(schedule, index)">

                                <div class="lesson_time">
                                    <span class="font-weight-bold">Lesson Start Time:</span>
                                    {{ schedule.formatted_lesson_time }}
                                </div>

                                <span class="font-weight-bold">Lesson End Time:</span>    

                                <span v-if="schedule && schedule.consecutive.after.length >= 1">
                                    {{ schedule.consecutive.after[schedule.consecutive.after.length -1].formatted_end_lesson_time }}
                                </span>
                                <span v-else>
                                    {{ schedule.formatted_end_lesson_time }}
                                </span>                                            

                                <div class="name_japanese">
                                    <span class="font-weight-bold">Name (Japanese):</span>
                                    <span id="tutor_fullname_japanese" v-if="schedule">
                                        {{ schedule.japanese_firstname }}
                                    </span>
                                </div>

                                <div class="name_japanese">
                                    <span class="font-weight-bold">Name (English):</span>
                                    <span id="tutor_fullname">
                                        {{ schedule.firstname }}
                                    </span>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div v-else>
                        No pending ratings.
                    </div>
                    <!--[end] schedule list-->
                </div>

                <div id="schedule-info-messages" v-else class="my-4">
                    <div class="text-center" v-if="!submitted">
                        No pending ratings.
                    </div>
                    <div v-else id="schedule-entry-submitted-container">
                        <!-- no list but submitted -->
                        <div class="my-4">
                            <div class="text-center">✅ ご評価ありがとうございました！</div>
                        </div>
                    </div>                        
                </div>
            </template>

            <template #modal-footer="{ ok, cancel, hide }">
                <b-button size="md" variant="danger" @click="cancel()"  v-if="submitted == false">
                    キャンセル
                </b-button>

                <b-button size="md" variant="primary" @click="submitStarRating()" v-if="schedules.length >= 1 && submitted == false">
                    レビューを送信
                </b-button>

            </template>

        </b-modal>

        <b-modal id="schedules-modal" centered header-class="bg-blue text-white" size="lg" no-auto-focus>
            <template #modal-title>
                受講履歴
            </template>
            <template #modal-header-close>
                <span aria-hidden="true" class="text-white">&times;</span>
            </template>

            <template #default>

                <table class="table table-bordered table-sm">
                    <tbody>
                        <tr>
                            <th class="small bg-light text-dark font-weight-bold">Lesson Start Time</th> 
                            <th class="small bg-light text-dark font-weight-bold">Lesson End Time</th> 
                            <th class="small bg-light text-dark font-weight-bold">Tutor</th> 
                        </tr>
                    </tbody>

                    <tr>
                        <td>{{ schedule.formatted_lesson_time }}</td>
                        <td>{{ schedule.formatted_end_lesson_time }}</td>
                        <td>{{ schedule.japanese_firstname }}</td>                            
                    </tr>

                    <tr v-for="item in schedule.consecutive.after">
                        <td>{{ item.formatted_lesson_time }}</td>
                        <td>{{ item.formatted_end_lesson_time }}</td>
                        <td>{{ schedule.japanese_firstname }}</td>                  
                    </tr>
                </table>
                    
              
            </template>

            <template #modal-footer="{ ok, cancel, hide }">
                <b-button size="md" variant="danger" @click="$bvModal.hide('schedules-modal')" >
                    キャンセル
                </b-button>
            </template>            

        </b-modal>

    </div>
</template>

<script>
export default {

    props: {
        memberid: {
            type: [Number, String],
            required: true
        },
        csrf_token: String,
        api_token: String,
    },
    data() {
        return {
            submitted: false,           //holds to show submitted and show submitted pane

            schedules: [],
            activeScheduleId: null,     //holds the ID of the active schedule
            activeScheduleIndex: null,  //holds the index key
            schedule: null,             //holds the selected schedule       
            teacherFeedback: null,      //Feeback of tacher
            selectedRating: 0,          //stars rating
            hoverRating: 0,             //hover star indicator

            loadingModalEl: null,
            loadingModal: null,

            hasErrorAlert: false,
            errorAlertMessage: null,

        };
    },
    mounted() {
        //this.fetchPendingRatings();
        this.hasPendingStarRating(); //show pending and add a stop notificatoin of pending
        
    },
    methods: {
        showSchedules(schedule) {
            this.$bvModal.show('schedules-modal');  //show the secondary modal focused only for listing of scheds
        },
        handleOutsideClick() {

            axios.post(`/api/stopRatingNotifications?api_token=${this.api_token}`, {              
                member_id:  this.memberid,             
            },{
                headers: { 'X-CSRF-TOKEN': this.csrf_token }
            }).then(response => {
                //console.log(response)               
            }).catch(error => {
                let errorMessage = 'An error occurred. Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                console.log(errorMessage);
            });
        },        
        resetModalVariables(bvModalEvt) {
            this.schedules = [];
            this.resetStarRatingsEntry();

         if ( bvModalEvt.trigger === 'headerclose' ||  bvModalEvt.trigger === 'footerclose' ||  bvModalEvt.trigger === 'cancel') {
                // User clicked outside the modal
                console.log('Footer / header! / Cancel buttons');
                this.handleOutsideClick();
            }   

            if ( bvModalEvt.trigger === 'backdrop') {
                // User clicked outside the modal
                console.log('Clicked outside the modal!');
                this.handleOutsideClick();
            }            
        },
        resetStarRatingsEntry() {
            this.activeScheduleId = null;       //holds the ID of the active schedule
            this.activeScheduleIndex = null;    //holds the index key
            this.schedule = null;               //holds the selected schedule       
            this.teacherFeedback = null;        //Feeback of tacher
            this.selectedRating = 0;            //stars rating
            this.hoverRating = 0;               //hover star indicator        
        },
        resetErrorAlerts() {
            this.hasErrorAlert = false;
            this.errorAlertMessage = null;
        },
        removeButton(index) {
            this.schedules.splice(index, 1);
        },     
        hasPendingStarRating() {

            axios.post(`/api/hasPendingStarRating?api_token=${this.api_token}`, {              
                member_id:  this.memberid,             
            },{
                headers: { 'X-CSRF-TOKEN': this.csrf_token }
            }).then(response => {

                if (response.data.hasUserStoppedRatingsNotifications == false) 
                {

                    if (response.data.hasPending == true) 
                    {
                        this.openStarRatingModal();
                    }
                }

               
            }).catch(error => {
                let errorMessage = 'An error occurred. Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                console.log(errorMessage);
            });
        },
        submitStarRating() {
          
            this.showLoadingModal();

            if (this.selectedRating < 1) 
            {                
                this.hasErrorAlert = true;
                this.errorAlertMessage = "Please select star rating, must be 1 to 5 star.";

                this.hideLoadingModal();
                return false;
            }

            //postTeacherStarRating
            axios.post(`/api/postTeacherStarRating?api_token=${this.api_token}`, {
                schedule_id: this.activeScheduleId,
                tutor_id: this.schedule.tutor_id,
                member_id: this.schedule.member_id,
                star_rating: this.selectedRating,
                feedback_message:  this.teacherFeedback,
                valid: true
            },{
                headers: { 'X-CSRF-TOKEN': this.csrf_token }
            }).then(response => {
                this.hideLoadingModal();
                this.removeButton(this.activeScheduleIndex);
                this.resetStarRatingsEntry();

                this.$nextTick(() => {
                    this.setActiveSchedule(this.schedules[this.activeScheduleIndex], this.activeScheduleIndex);                  
                    this.submitted = true;

                    // After 3 seconds, reset the view
                    setTimeout(() => {
                        this.submitted = false;                    
                    }, 2000);

                });
                
            }).catch(error => {
                let errorMessage = 'An error occurred. Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                console.log(errorMessage);;
            });

        },
        fetchPendingRatings() {
            axios.post(`/api/getStarRatingPendingList?api_token=${this.api_token}`, {
                member_id: this.memberid
            },
            {
                headers: { 'X-CSRF-TOKEN': this.csrf_token }
            }).then(response => {
                this.hideLoadingModal();
                this.$nextTick(() => {

                    this.schedules = response.data.schedules;

                    if (this.schedules.length >= 1) {
                        this.setActiveSchedule(this.schedules[0], 0);
                    }

                    this.$bvModal.show('star-rating-modal');
                });
            }).catch(error => {
                let errorMessage = 'An error occurred. Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                alert(errorMessage);

                this.hideLoadingModal();
            });
        },

        selectRating(value) {
            this.selectedRating = value;
            this.resetErrorAlerts();
        },
        openStarRatingModal() {
            this.showLoadingModal();
            this.fetchPendingRatings();
        },
        showLoadingModal() {
            document.getElementById('loadingModal').style.display = 'block';
        },
        hideLoadingModal() {
            setTimeout(() => {
                document.getElementById('loadingModal').style.display = 'none';
            }, 1);
        },
        getStorageUrl(path) {
            return path ? `/storage/${path}` : '/storage/user_images/noimage.jpg';
        },
        setActiveSchedule(schedule, index) {
            console.log("first active ", schedule);
            this.activeScheduleIndex = index;

            if (schedule && schedule.id) {
                this.activeScheduleId = schedule.id;
                this.schedule = schedule;
            } else {

                //the last schedule selected since it is empty, try testing if there are schedules so it can point to the firs tone
                if (this.schedules.length >= 1) {
                    this.setActiveSchedule(this.schedules[0], 0);

                    document.querySelector('.scrollable-list-group').scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });                    
                }
            }
        }


    }
};
</script>

<style scoped>
.scrollable-list-group {
    max-height: 480px;
    /* adjust height as needed */
    overflow-y: auto;
}
</style>